/**
 * @typedef {Object} AudioPriority
 * @property {number} [priority=1] - The priority level of the audio
 *
 * @typedef {HTMLAudioElement & AudioPriority} HwpTvAudio
 *
 * @typedef {object} HwpTvAudioData
 * @property {string} id
 * @property {string|string[]} src
 * @property {number} priority
 *
 * @typedef {object} AudioManagerOptions
 * @property {string} [contentUrl=/hwpHub/json/audioData.json] - The URL to fetch audio data from.
 * @property {boolean} [muted=false] - Whether the AudioManager is muted by default.
 * @property {boolean} [supportsMultipleTracks=false] - Whether the AudioManager supports playing multiple audio tracks simultaneously.
 */

export const FADE_DURATION = 1;
export const VOLUME_BG_DEFAULT = 0.33;

/**
 * @enum {typeof EVENTS[keyof typeof EVENTS]}
 */
export const EVENTS = Object.freeze({
	initialized: 'initialized',
});

/**
 * @enum {typeof SOUNDS[keyof typeof SOUNDS]}
 */
export const SOUNDS = Object.freeze({
	ballotPick: 'ballotPick',
	bracketPick: 'bracketPick',
	buttonChange: 'buttonChange',
	buttonSelect: 'buttonSelect',
	connectFourDrop: 'connectFourDrop',
	connectFourLose: 'connectFourLose',
	connectFourTie: 'connectFourTie',
	connectFourWin: 'connectFourWin',
	crosswordBonus: 'crosswordBonus',
	crosswordCorrect: 'crosswordCorrect',
	crosswordIncorrect: 'crosswordIncorrect',
	dxCorrect: 'dxCorrect',
	dxIncorrect: 'dxIncorrect',
	dxTimerExpired: 'dx-timer-expired',
	hubAchievementActivated: 'ding',
	hubArcadeChange: 'hubChangeOption',
	hubArcadeLaunch: 'hubLaunchArcade',
	hubRoomChange: 'hubChangeOption',
	hubLegalChange: 'hubChangeOption',
	lockboxFail: 'lockboxFail',
	lockboxSuccess: 'lockboxSuccess',
	lockboxTryUnlock: 'lockboxTryUnlock',
	mmFocus: 'mmFocus',
	mmFlip: 'mmFlip',
	mmMatch: 'mmMatch',
	mmMiss: 'mmMiss',
	pathNodeSelected: 'pathNodeSelected',
	pathStart: 'pathStart',
	sceneStreakIncorrectChoice: 'sceneStreakIncorrectChoice',
	sceneStreakOverlay: 'sceneStreakOverlay',
	sceneStreakPointsReward: 'sceneStreakPointsReward',
	slideFailed: 'slideFailed',
	slidePuzzleComplete: 'slidePuzzleComplete',
	slidePuzzleTimeExpired: 'slidePuzzleTimeExpired',
	timerExpired: 'timerExpired',
	timerLow: 'timeLow',
	tilePopNotAPop: 'tilePopNotAPop',
	tilePoppedBoardEmpty: 'tilePoppedBoardEmpty',
	tilePopPopped: 'tilePopPopped',
	triviaCorrect: 'triviaCorrect',
	triviaIncorrect: 'triviaIncorrect',
	wellConnectedCorrect: 'wellConnectedCorrect',
	wellConnectedIncorrect: 'wellConnectedIncorrect',
	wellConnectedTimeExpired: 'wellConnectedTimeExpired',
	wordSearchCorrect: 'wordSearchCorrect',
	wordSearchFoundAll: 'wordSearchFoundAll',
	wordSearchIncorrect: 'wordSearchIncorrect',
});
